/**
 * Eksekusi JTM Approval Module
 * URLs injected via window.EksekusiJtmApprovalConfig (PHP bridge).
 */
export function initEksekusiJtmApproval() {
    const cfg = window.EksekusiJtmApprovalConfig || {};
    let currentId = null;

    // ─── View Detail Modal ───────────────────────────────────────────────────
    $('.btn-view-detail').on('click', function () {
        const btn = $(this);
        currentId = btn.data('id');

        $('#modal_kode_wo').text(btn.data('wo'));
        $('#modal_kode_inspeksi').text(btn.data('inspeksi'));
        $('#modal_pelaksana').text(btn.data('pelaksana'));
        $('#modal_piket_petugas').text(btn.data('piket-petugas') || '-');
        $('#modal_tanggal').text(btn.data('tanggal'));
        $('#modal_temuan').text(btn.data('komponen') + ' | ' + btn.data('kondisi'));
        $('#modal_tiang_detail').text('Tiang: ' + btn.data('tiang') + ' - ULP ' + btn.data('ulp'));

        const lat = btn.data('latitude');
        const lng = btn.data('longitude');
        if (lat && lng && lat !== '-' && lng !== '-') {
            $('#modal_koordinat').text(lat + ', ' + lng);
            $('#modal_map_link').attr('href', `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`).show();
        } else {
            $('#modal_koordinat').text('-');
            $('#modal_map_link').hide();
        }

        const status = btn.data('status');
        const statusMap = {
            'KENDALA': '<span class="badge bg-danger text-white">KENDALA</span>',
            'WAITING_APPROVAL': '<span class="badge bg-warning text-dark">WAITING APPROVAL</span>',
            'SELESAI': '<span class="badge bg-success text-white">SELESAI</span>',
        };
        $('#modal_status').html(statusMap[status] || `<span class="badge bg-secondary text-white">${status || '-'}</span>`);

        if (status === 'KENDALA') {
            $('#modal_kendala').text(btn.data('kendala') || '-');
            $('#modal_kendala_wrapper').show();
        } else {
            $('#modal_kendala_wrapper').hide();
        }

        $('#modal_keterangan').text(btn.data('keterangan'));

        // Load 4 documentation images
        $('#modal_img_temuan').attr('src', btn.data('temuan') || '');
        $('#modal_img_sebelum').attr('src', btn.data('sebelum') || '');
        $('#modal_img_sesudah').attr('src', btn.data('sesudah') || '');
        $('#modal_img_eviden').attr('src', btn.data('eviden') || '');

        $('#modalVerifikasi').modal('show');
    });

    // ─── Image Zoom Preview ──────────────────────────────────────────────────
    $(document).on('click', '.previewable-img', function () {
        const src = $(this).attr('src');
        if (src && !src.includes('svg')) {
            $('#fullPreviewImg').attr('src', src);
            $('#modalImgPreview').modal('show');
        }
    });

    // ─── Approve ─────────────────────────────────────────────────────────────
    $(document).on('click', '.btn-approve-direct, #btnApproveAction', function () {
        const id = $(this).data('id') || currentId;
        if (!id) return;

        Swal.fire({
            title: 'Setujui Hasil Eksekusi?',
            text: 'Laporan eksekusi ini akan disahkan dan status penugasan & temuan menjadi SELESAI.',
            icon: 'question', showCancelButton: true,
            confirmButtonText: 'Ya, Setujui!', cancelButtonText: 'Batal',
            customClass: { confirmButton: 'btn btn-success rounded-pill px-4 me-2', cancelButton: 'btn btn-light rounded-pill px-4' },
            buttonsStyling: false
        }).then(result => {
            if (!result.isConfirmed) return;
            Swal.fire({ title: 'Memproses...', didOpen: () => Swal.showLoading() });

            $.ajax({
                url: cfg.urlApprove + '/' + id,
                type: 'POST',
                data: { [cfg.csrfToken]: cfg.csrfHash },
                success(res) {
                    Swal.fire({ icon: 'success', title: 'Berhasil!', text: res.message, confirmButtonClass: 'btn btn-primary rounded-pill px-4', buttonsStyling: false })
                        .then(() => location.reload());
                },
                error(xhr) {
                    Swal.fire({ icon: 'error', title: 'Gagal', text: xhr.responseJSON?.message || 'Terjadi kesalahan sistem.', confirmButtonClass: 'btn btn-primary rounded-pill px-4', buttonsStyling: false });
                }
            });
        });
    });

    // ─── Reject ──────────────────────────────────────────────────────────────
    $(document).on('click', '.btn-reject-direct, #btnRejectAction', function () {
        const id = $(this).data('id') || currentId;
        if (!id) return;

        // Hide Bootstrap modal to prevent focus trapping issue with SweetAlert input
        const isFromModal = $(this).attr('id') === 'btnRejectAction';
        if (isFromModal) {
            $('#modalVerifikasi').modal('hide');
        }

        Swal.fire({
            title: 'Tolak Hasil Eksekusi?',
            text: 'Masukkan alasan penolakan. Laporan eksekusi akan dikembalikan ke status DITUGASKAN.',
            icon: 'warning', input: 'textarea',
            inputPlaceholder: 'Tulis alasan penolakan di sini...',
            inputAttributes: { 'aria-label': 'Tulis alasan penolakan di sini' },
            showCancelButton: true,
            confirmButtonText: 'Kirim Penolakan', cancelButtonText: 'Batal',
            customClass: { confirmButton: 'btn btn-danger rounded-pill px-4 me-2', cancelButton: 'btn btn-light rounded-pill px-4' },
            buttonsStyling: false,
            inputValidator: value => !value ? 'Alasan penolakan harus diisi!' : undefined
        }).then(result => {
            if (!result.isConfirmed) {
                if (isFromModal) {
                    $('#modalVerifikasi').modal('show');
                }
                return;
            }
            Swal.fire({ title: 'Memproses...', didOpen: () => Swal.showLoading() });

            $.ajax({
                url: cfg.urlReject + '/' + id,
                type: 'POST',
                data: { [cfg.csrfToken]: cfg.csrfHash, notes: result.value },
                success(res) {
                    Swal.fire({ icon: 'success', title: 'Berhasil Ditolak!', text: res.message, confirmButtonClass: 'btn btn-primary rounded-pill px-4', buttonsStyling: false })
                        .then(() => location.reload());
                },
                error(xhr) {
                    Swal.fire({ icon: 'error', title: 'Gagal', text: xhr.responseJSON?.message || 'Terjadi kesalahan sistem.', confirmButtonClass: 'btn btn-primary rounded-pill px-4', buttonsStyling: false });
                }
            });
        });
    });
}
